import { Text } from '@meterup/atto';
import { PresignedImage } from '@meterup/common';
import { DateTime } from 'luxon';
import { memo } from 'react';

import { CopyableMonoOrNoValue } from '../Devices/Insights';
import { NoValue } from '../NoValue';

export const CellOrNoValue = memo(({ value }: { value: string | number | null | undefined }) => {
  if (value == null || value === '') return <NoValue />;

  return <Text>{value}</Text>;
});

export const MonoCellOrNoValue = memo(
  ({ value }: { value: string | number | null | undefined }) => {
    if (value == null || value === '') return <NoValue />;

    return <CopyableMonoOrNoValue value={value} wrap="nowrap" />;
  },
);

export const DateTimeCellOrNoValue = memo(
  ({
    value,
    format = DateTime.DATETIME_MED_WITH_SECONDS,
  }: {
    value: string | null | undefined;
    format?: Intl.DateTimeFormatOptions;
  }) => {
    if (!value) return <NoValue />;

    return DateTime.fromISO(value).toLocaleString(format);
  },
);

export const PresignedImageCell = memo(({ value }: { value: string | null | undefined }) => {
  if (!value) return <NoValue />;

  return <PresignedImage s3Key={value} />;
});
